export default "__VITE_ASSET__61a1a4d4__"